import React, { FunctionComponent } from 'react';
import { Input } from 'components/UI/V3/Forms/Input/Input';
import styles from './RateRuleNameSection.module.scss';

interface RateRuleNameSectionProps {
    value: string;
    onChange: (value: string) => void;
    error?: string;
}

export const RateRuleNameSection: FunctionComponent<RateRuleNameSectionProps> = ({ value, onChange, error }) => {
    return (
        <div className={styles.container}>
            <h3 className={styles.title}>
                Rate Rule Name <span className={styles.required}>*</span>
            </h3>

            <Input
                value={value}
                onChange={e => onChange(e.target.value)}
                placeholder="Ex. 20% Increase at 70% occupancy"
                error={error}
            />
        </div>
    );
};
